import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import { NotificationProvider } from "@certx/shared";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "@certx/shared/styles/App.css";
import "@certx/shared/styles/themeCustomization.css";

export default function App() {
  return (
    <PrimeReactProvider>
      <div className="app">
        <BrowserRouter>
          <NotificationProvider>
            <Router />
          </NotificationProvider>
        </BrowserRouter>
      </div>
    </PrimeReactProvider>
  );
}
